import * as roomActions from './room'
import { roomTypes } from './roomTypes'

export const roomType = roomTypes
export default roomActions
